module.exports = __webpack_public_path__ + "assets/envelope.1d92f050a2f076b70aea232cc97a7753d13643f6fb4dfbb64264eac67ccdddd5.png";